export default __webpack_public_path__ + "static/media/car_alert.1ee88a26.mp3";